(() => {
  const configNode = document.getElementById('CodebrwnMarketExpiryConfig');
  const form = document.getElementById('CodebrwnMarketExpiryForm');
  if (!configNode || !form || window.Shopify?.designMode) return;

  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const key = 'codebrwn-market-preference-v1';
  const lifetime = 24 * 60 * 60 * 1000;
  const retryDelay = 5 * 60 * 1000;
  const read = () => {
    try { return JSON.parse(localStorage.getItem(key)); } catch { return null; }
  };
  const save = (value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
  };
  const remember = () => save({ expiresAt: Date.now() + lifetime, retryAfter: 0 });
  const valid = (value) => Number.isFinite(value?.expiresAt) && value.expiresAt > 0;
  const isCountryForm = (element) => {
    const action = element?.getAttribute('action');
    if (!action) return false;
    try {
      const url = new URL(action, window.location.href);
      return url.origin === window.location.origin && /\/localization\/?$/.test(url.pathname);
    } catch { return false; }
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest?.('.wp-currency__option[data-currency], localization-form a[data-value]');
    if (option && (option.matches('.wp-currency__option') || isCountryForm(option.closest('form')))) remember();
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.name === 'country_code' && isCountryForm(event.target.form)) remember();
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target !== form && isCountryForm(event.target) && event.target.querySelector('[name="country_code"]')) remember();
  }, true);

  const check = async () => {
    if (document.visibilityState === 'hidden') return;
    const now = Date.now();
    const state = read();
    if (!valid(state)) { remember(); return; }
    if (state.expiresAt > now || state.retryAfter > now) return;
    const attempt = { ...state, retryAfter: now + retryDelay };
    if (!save(attempt)) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(`${config.root}browsing_context_suggestions.json?country[enabled]=true`, {
        credentials: 'same-origin', signal: controller.signal,
      });
      if (!response.ok) return;
      const result = await response.json();
      const country = result.detected_values?.country?.handle;
      if (!config.countries.includes(country)) return;
      const latest = read();
      if (latest?.expiresAt !== state.expiresAt || latest?.retryAfter !== attempt.retryAfter) return;
      let displayCurrency;
      try {
        displayCurrency = localStorage.getItem('wp-currency-code');
        localStorage.removeItem('wp-currency-code');
      } catch { return; }
      if (!remember()) return;
      if (country === config.country && (!displayCurrency || displayCurrency === 'AUTO')) return;
      form.querySelector('[name="country_code"]').value = country;
      form.querySelector('[name="return_to"]').value = window.location.pathname + window.location.search;
      HTMLFormElement.prototype.submit.call(form);
    } catch {
      return;
    } finally {
      clearTimeout(timeout);
    }
  };
  check();
  window.addEventListener('pageshow', check);
})();
